export enum TimeTypeEnum {
    Start = 1,
    End = 2,
}

export default TimeTypeEnum;
